//@flow

import * as React from "react"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"

const Container = styled.div`
  position: absolute;
  border-radius: 2rem;
  background: #000;
  padding: 2rem;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  width: ${props => props.width}px;
  pointer-events: none;
  z-index: 4;
`

const Headline = styled.h3`
  font-family: "din-condensed";
  font-weight: 400;
  font-size: 40px;
  color: #fff;
  margin: 0;
  text-transform: uppercase;
`

const Description = Headline.extend`
  text-transform: none;
  font-size: 30px;
  color: #7f7f7f;
  margin-top: 1rem;
`.withComponent("p")

const ToolTip = styled.div`
  position: absolute;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`

type Props = {
  anchorPoint: { x: number, y: number },
  x: number,
  y: number,
  width: number,
  headline: string,
  description: string,
  innerRef?: (el: ?HTMLElement) => any
}

type State = {
  containerHeight: number
}

class Popup extends React.Component<Props, State> {
  container: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.state = { containerHeight: 0 }
  }

  componentDidMount() {
    this.setState(() => ({
      containerHeight: this.container ? this.container.offsetHeight : 0
    }))
  }

  componentDidUpdate(prevProps: Props) {
    const { anchorPoint: { x, y } } = this.props
    if (prevProps.anchorPoint.x !== x || prevProps.anchorPoint.y !== y) {
      this.setState(() => ({
        containerHeight: this.container ? this.container.offsetHeight : 0
      }))
    }
  }

  render() {
    const {
      anchorPoint,
      x,
      y,
      width,
      headline,
      description,
      innerRef
    } = this.props
    const { containerHeight } = this.state

    const tipWidth = 60

    const offsetX =
      anchorPoint.x > x ? anchorPoint.x - width - x : x - anchorPoint.x
    const tipContainerWidth = Math.abs(offsetX)
    const tipX = anchorPoint.x > x ? width - 1 : -tipContainerWidth

    const tipY = containerHeight / 2 - tipWidth / 2
    const offsetY = tipY + y - anchorPoint.y
    const tipContainerHeight = Math.abs(offsetY)

    const data =
      anchorPoint.x > x
        ? `M0 0 L0 ${tipWidth} L${tipContainerWidth} ${tipContainerHeight} L0 0 z`
        : `M${tipContainerWidth} 0 L${tipContainerWidth} ${tipWidth} L0 ${tipContainerHeight} L${tipContainerWidth} 0 z`
    return (
      <Container
        top={y}
        left={x}
        width={width}
        innerRef={el => {
          this.container = el
          innerRef && innerRef(el)
        }}
      >
        <Headline>
          <FormattedMessage id={headline} />
        </Headline>
        <Description>
          <FormattedMessage id={description} />
        </Description>
        <ToolTip
          top={tipY}
          left={tipX}
          height={tipContainerHeight}
          width={tipContainerWidth}
        >
          <svg height="100%" width="100%">
            <path d={data} fill="#000" />
          </svg>
        </ToolTip>
      </Container>
    )
  }
}

export default Popup



// WEBPACK FOOTER //
// ./src/Kiosk/BodyView/Popup.js